import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { useAppContext } from '../../../../../../../../AppModulesWrapper';
import { selectRecommendedPackages } from '../../../../../../../reducers/v2/recommendedPackages/selectors';
import { selectAnalyticsVariant } from '../../../../../../../selectors/analytics';
import { IRecommendedPackage } from '../../../../../../../types/reducers/recommendedPackages';

import {
  IUseRecommendedPackagesAnalytics,
  ITrackShowRecommendedPackagesExtra,
  ITrackDefaultPublicationClickExtra,
  ITrackRecommendedPackageClickExtra,
} from '../types';
import { mapPackageTrackingData } from './utils';

export const useRecommendedPackagesAnalytics = (): IUseRecommendedPackagesAnalytics => {
  const { analytics } = useAppContext();

  const recommendedPackages = useSelector(selectRecommendedPackages);
  const vas = useSelector(selectAnalyticsVariant);

  const trackShowRecommendedPackagesWidget = useCallback(() => {
    analytics.send<ITrackShowRecommendedPackagesExtra>({
      action: 'publish_terms_block_show_sopr',
      label: 'package',
      extra: {
        package_info: recommendedPackages.map(mapPackageTrackingData),
        package_block_default_value: 'announcement',
        vas,
      },
    });
  }, [analytics, recommendedPackages, vas]);

  const trackDefaultPublicationClick = useCallback(() => {
    analytics.send<ITrackDefaultPublicationClickExtra>({
      action: 'publish_terms_block_click_sopr',
      label: 'announcement',
      extra: {
        package_block_default_value: 'announcement',
        vas,
      },
    });
  }, [analytics, vas]);

  const trackRecommendedPackageClick = useCallback(
    (recommendedPackage: IRecommendedPackage) => {
      analytics.send<ITrackRecommendedPackageClickExtra>({
        action: 'publish_terms_block_click_sopr',
        label: 'package',
        extra: {
          package_info: mapPackageTrackingData(recommendedPackage),
          package_block_default_value: 'announcement',
          vas,
        },
      });
    },
    [analytics, vas],
  );

  return { trackShowRecommendedPackagesWidget, trackDefaultPublicationClick, trackRecommendedPackageClick };
};
